// Property-autocomplete dropdown behaviour.
//
// `@symbo.ls/ui` does NOT exist in this checkout: `node_modules/@symbo.ls/ui`
// is a symlink to `platform/uikit/ui`, a directory that was never checked out
// (dangling since Jan 2026). Excluding this module from the barrel was not
// enough — a Symbols project discovers `functions/` BY DIRECTORY, so the
// bundler compiles every file here whether the barrel exports it or not, and
// the unresolvable import failed the entire `workspace` dev build:
//
//   @parcel/core: Failed to resolve '@symbo.ls/ui/Autocomplete/props'
//
// Parcel then serves a build-error page at HTTP 200 while the browser keeps
// running the last good bundle, so the app looks alive and merely stale —
// which is how this survived unnoticed.
//
// `autocompletePropKey` and `prefillValue` were the only consumers of
// `props` / `propsKeys` / `getPropertyValues`. With that package absent they
// could not run at all — they threw at module load before they could be
// called. They are removed rather than left as a build-breaking stub; restore
// them together with a real source for the property catalogue. The three
// functions below never needed it and keep working.
//
// The siblings that never touched the import live in ./prefill-values.js.

export function openAutocompleteDropdown() {
  if (this.state.dropdown) {
    return
  }

  this.state.replace({ dropdown: true })
}

export function closeAutocompleteDropdown() {
  this.state.replace({ dropdown: false })
}

// sequenceNameToDSItem, prefillSequenceValue, prefillColorValue,
// prefillFunctionValue, prefillComponentValue, setPrefillValues moved to
// ./prefill-values.js (they don't need this file's broken import — see the
// header comment above).

export function moveThroughList(isDown) {
  if (!this.state.dropdown) {
    return
  }

  const { list, prefill } = this.state

  let nextIndex = list.indexOf(prefill)
  if (isDown) {
    nextIndex = nextIndex + 1 > list.length - 1 ? 0 : nextIndex + 1
  } else {
    nextIndex = nextIndex - 1 < 0 ? list.length - 1 : nextIndex - 1
  }

  this.state.update({ prefill: list[nextIndex] })
}
